export default "__VITE_ASSET__922ae17f__"